// app/frontend/data/projects.ts
import { Project } from "./types";

export const projects: Project[] = [
  {
    id: 1,
    slug: "ai-legal-document-extraction",
    title: "AI Legal Document Extraction System",
    description:
      "A multi-agent AI pipeline for extracting structured data from legal documents. Built with LangGraph orchestration and FastAPI, validated at ~98% accuracy across 208 of 212 real tickets. Features a step-through debugger, confidence scoring, human-in-the-loop routing, golden test suite, and admin performance dashboard. Client-side integration with Salesforce for attorney matching and pricing estimation.",
    clientName: "Confidential (Legal Tech)",
    projectType: "Software Development",
    projectSubtype: "AI / Applied ML",
    featuredImageUrl:
      "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=800&h=450&fit=crop",
    status: "completed",
    startDate: "2026-02-01",
    endDate: "2026-07-01",
    skills: [
      "Multi-Agent AI",
      "LangGraph",
      "Applied ML",
      "System Architecture",
      "Golden Test Suite",
      "Human-in-the-Loop",
    ],
    tools: [
      "Python",
      "FastAPI",
      "LangGraph",
      "OpenAI",
      "Anthropic Claude",
      "Salesforce API",
    ],
    primarySkill: "Multi-Agent AI",
    primaryTool: "LangGraph",
    published: true,
    media: [],
  },
  {
    id: 2,
    slug: "nonprofit-automation-platform",
    title: "Nonprofit Automation Platform",
    description:
      "Full operational infrastructure for a nonprofit tech-training org, built solo over 9 months. 26 active n8n workflows orchestrating 14+ Notion databases across client intake, enrollment tracking, weekly touchpoint check-ins, volunteer management, document signing, daily AI briefings, and a Salesforce-to-Notion sync pipeline. 12 external APIs integrated. Also led a duplicate-client data audit: 597 records → 313 canonical clients, root cause traced to batch import logic, sync layer rewritten with upsert-on-Salesforce-ID logic to prevent recurrence.",
    clientName: "Confidential (Nonprofit)",
    projectType: "Software Development",
    projectSubtype: "Automation / Ops",
    featuredImageUrl:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=450&fit=crop",
    status: "completed",
    startDate: "2025-08-20",
    endDate: "2026-05-29",
    skills: [
      "Workflow Automation",
      "System Design",
      "Data Architecture",
      "API Integration",
      "AI Vision Pipelines",
      "Data Auditing",
    ],
    tools: [
      "n8n",
      "Notion",
      "Salesforce",
      "Google Workspace",
      "Anthropic Claude",
      "OpenAI",
      "Slack",
      "BoldSign",
      "Tally",
    ],
    primarySkill: "Workflow Automation",
    primaryTool: "n8n",
    published: true,
    media: [],
  },
  {
    id: 3,
    slug: "wherecanwedance",
    title: "WhereCanWeDance.com",
    description:
      "Austin's social dance discovery platform. A community-facing directory connecting dancers to classes, socials, and workshops across kizomba, salsa, bachata, and more. Built with Rails 8, Inertia, and React — includes artist profiles, event listings, ticket sales, and multi-currency artist payouts. Live product in active use by the Austin dance community.",
    clientName: "",
    projectUrl: "https://www.wherecanwedance.com",
    projectType: "Software Development",
    projectSubtype: "Community Platform",
    featuredImageUrl:
      "https://dancewise.s3.us-east-1.amazonaws.com/NEW+WCWD+SEO+IMAGE+TAGLINE.jpg",
    status: "in_progress",
    skills: [
      "Full-Stack Development",
      "Product Design",
      "Community Building",
      "Payments Integration",
    ],
    tools: [
      "Rails",
      "React",
      "Inertia.js",
      "Mantine",
      "PostgreSQL",
      "Stripe",
    ],
    primarySkill: "Full-Stack Development",
    primaryTool: "Rails",
    published: true,
    media: [],
  },
  {
    id: 4,
    slug: "vidhive",
    title: "VidHive",
    description:
      "A video highlight capture tool for learners and creators. Paste a YouTube or Vimeo link, set a per-video goal, and get AI-suggested highlights ranked by relevance — or capture moments manually with keyboard hotkeys for sports and dance videos. Rails 8 + Inertia + React + SolidQueue background jobs + OpenAI for goal-aware transcript ranking. Free tier + Stripe Checkout paywall for unlimited access.",
    clientName: "",
    projectType: "Software Development",
    projectSubtype: "Product",
    featuredImageUrl:
      "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=800&h=450&fit=crop",
    status: "in_progress",
    startDate: "2026-04-01",
    skills: [
      "Full-Stack Development",
      "Applied AI",
      "Product Design",
      "Payments Integration",
    ],
    tools: [
      "Rails",
      "React",
      "Inertia.js",
      "Mantine",
      "OpenAI",
      "Stripe",
      "SolidQueue",
    ],
    primarySkill: "Full-Stack Development",
    primaryTool: "Rails",
    published: true,
    media: [],
  },
  {
    id: 5,
    slug: "learntokiz",
    title: "Learntokiz.io",
    description:
      "Online Urban Kizomba education platform. Structured lesson curriculum, technique breakdowns, and musicality training for dancers at every level. Built as the digital extension of my decade-plus of teaching, delivering culturally grounded instruction to students who can't attend in person.",
    clientName: "",
    projectUrl: "https://learntokiz.io",
    projectType: "Software Development",
    projectSubtype: "Education Platform",
    featuredImageUrl:
      "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=800&h=450&fit=crop",
    status: "in_progress",
    skills: [
      "Full-Stack Development",
      "Product Design",
      "Instructional Design",
    ],
    tools: [
      "Rails",
      "React",
      "Inertia.js",
      "Mantine",
    ],
    primarySkill: "Full-Stack Development",
    primaryTool: "Rails",
    published: true,
    media: [],
  },
  {
    id: 6,
    slug: "neokizfest-refund-system",
    title: "NeoKizFest Public Accountability System",
    description:
      "A public refund + community accountability platform built when an eight-year festival came to an end. Rather than disappearing on a $34K liability across 206 ticket holders, I built and ran a fully transparent refund system in public for 48+ days. Live progress dashboard, community messages gallery, and a Flowers gallery for farewell notes. 42.6% of filers voluntarily waived their refund — the community itself erased ~40% of the total obligation. Rails 8 + Inertia + React, Notion as the primary data store, Kamal deploy to DigitalOcean.",
    clientName: "",
    projectUrl: "https://neokizfest.com",
    projectType: "Software Development",
    projectSubtype: "Product / Community",
    featuredImageUrl:
      "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800&h=450&fit=crop",
    status: "completed",
    startDate: "2026-02-14",
    endDate: "2026-05-15",
    skills: [
      "Full-Stack Development",
      "Product Design",
      "Community Systems",
      "Public Accountability",
    ],
    tools: [
      "Rails",
      "React",
      "Inertia.js",
      "Notion API",
      "Brevo",
      "Kamal",
      "DigitalOcean",
    ],
    primarySkill: "Full-Stack Development",
    primaryTool: "Rails",
    published: true,
    media: [],
  },
  {
    id: 7,
    slug: "headless-cms-website-migration",
    title: "Headless CMS Website Migration",
    description:
      "Migrated a 13+ page legal website from hardcoded WordPress into a modern Next.js + Strapi headless CMS architecture. Built a 40+ component library with a tiered design-token system (primitives → semantic aliases → component usage) synced to Figma via Code Connect. CMS-managed analytics + tag injection empowered non-technical users to control tracking without engineering support. Strapi DynamicZone schemas gave per-section color and label controls at WordPress-parity granularity.",
    clientName: "Confidential (Legal Tech)",
    projectType: "Software Development",
    projectSubtype: "Frontend / CMS Architecture",
    featuredImageUrl:
      "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800&h=450&fit=crop",
    status: "completed",
    startDate: "2026-02-01",
    endDate: "2026-07-01",
    skills: [
      "Frontend Architecture",
      "Design Systems",
      "Headless CMS",
      "Figma Code Connect",
      "Component Libraries",
    ],
    tools: [
      "Next.js",
      "React",
      "TypeScript",
      "Mantine",
      "Strapi",
      "Figma",
      "AWS S3",
      "AWS Amplify",
    ],
    primarySkill: "Frontend Architecture",
    primaryTool: "Next.js",
    published: true,
    media: [],
  },
  {
    id: 8,
    slug: "phrase-flow-visualizer-002",
    title: "Phrase Flow Visualizer 002",
    description:
      "A dynamic motion graphics visualization that brings music to life through custom After Effects animations. Combines my DJing expertise with advanced motion graphics to create an immersive visual experience that responds to musical phrases and beats.",
    clientName: "",
    projectUrl: "https://www.youtube.com/watch?v=yXeW-A6SgAU",
    projectType: "Digital Media",
    projectSubtype: "Video Production",
    featuredImageUrl:
      "https://d3fseuzsjuxdh2.cloudfront.net/h9yw1kkn6s94dllsessykty8u6tx",
    status: "completed",
    startDate: "2025-04-30",
    endDate: "2025-05-17",
    skills: [
      "Motion Graphics",
      "After Effects",
      "Video Editing",
      "Music Visualization",
      "DJing",
    ],
    tools: [
      "Adobe After Effects",
      "Adobe Premiere Pro",
      "DJing Software",
      "Audio Analysis",
    ],
    primarySkill: "Motion Graphics",
    primaryTool: "Adobe After Effects",
    published: true,
    media: [],
  },
];

// Helper functions for filtering
export function getPublishedProjects(): Project[] {
  return projects.filter((p) => p.published);
}

export function getProjectBySlug(slug: string): Project | undefined {
  return projects.find((p) => p.slug === slug);
}

export function getProjectsByType(type: string): Project[] {
  return projects.filter((p) => p.projectType === type);
}

export function getAllProjectTypes(): string[] {
  return Array.from(new Set(projects.map((p) => p.projectType)));
}

export function getAllSkills(): string[] {
  return Array.from(new Set(projects.flatMap((p) => p.skills)));
}

export function getAllTools(): string[] {
  return Array.from(new Set(projects.flatMap((p) => p.tools)));
}
